function prefixClasses(classes, prefix = '') {
    return classes.map((c)=>[
            c,
            `${prefix}${c}`
        ]).reduce((prev, cur)=>{
        prev[cur[0]] = cur[1];
        return prev;
    }, {});
}
function classNamesForModifierOverDisplays(modifierPrefix, modifier, displays) {
    const classNames = !!displays && Array.isArray(displays) && displays.map((display)=>`${modifierPrefix}${display ? display : ''}${modifier ? modifier : ''}`);
    return classNames || [];
}
export { classNamesForModifierOverDisplays };
export { prefixClasses };
export default {
    classNamesForModifierOverDisplays,
    prefixClasses
};
